import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { TASKS } from '@shared/api/endpoints';
import type { TaskStep } from '@tailorcast/shared-types';

export function useTaskSteps(taskId: string | undefined) {
  return useQuery({
    queryKey: ['task', taskId, 'steps'],
    queryFn: () => api.get<{ steps: TaskStep[] }>(TASKS.STEPS(taskId!)),
    enabled: !!taskId,
  });
}
